import { createQueryKeys } from '@shared/api';

/**
 * Ключи журнала обновлений.
 *
 * Семейство одно и без параметров: запрос у журнала ровно один, разводить его нечем — ни фильтров,
 * ни страниц ручка не знает. Ключ всё равно собирается фабрикой, а не литералом `['releases']`:
 * форма ключа тогда та же, что у остальных сущностей, и место для второго семейства уже есть —
 * если журнал когда-нибудь научится отдавать выпуск поштучно.
 */
export const releaseKeys = createQueryKeys('releases', {
  list: () => ['list'],
});
